module.exports = __webpack_public_path__ + "static/media/Country-Club-Village-of-Plymouth-Sub-Covenants.19354359.pdf";